import React from 'react';
import { Outlet } from 'react-router';
import ListingProvider from './providers/Listing';

import './ListingEditWizard.styles.scss';

const ListingEditWizard: React.FC = () => (
  <div className="listing-creation-wizard listing-edit-wizard">
    <ListingProvider>
      <Outlet />
    </ListingProvider>
  </div>
);

export default ListingEditWizard;
